
export {ClayLinkContext} from '@clayui/link';
import __x__ from '@clayui/link';export default __x__;